<template>
  <section
    v-if="!slotIsEmpty"
    class="product-section accordion-drawer"
    :class="{ '-no-expand': isStatic, '-notopen': isClosing || !open }"
    :style="backgroundColor"
  >
    <h2
      v-if="title && isMobile"
      :style="(open && !isClosing) || isStatic ? backgroundColor : {}"
    >
      <button
        :aria-expanded="[(open && !isClosing) || isStatic]"
        :aria-controls="'section-' + reference"
        :id="'pageTab-' + reference"
        @click="toggle"
      >
        <span>{{ title }}</span>
        <span class="arrow div -black">
          <span class="arrow-left"></span>
          <span class="arrow-right"></span>
        </span>
      </button>
    </h2>

    <div
      :id="'pageTab-' + reference"
      class="product-section-wrapper grid"
      :class="[open || isStatic ? openDrawer : closeDrawer]"
      :style="backgroundColor"
      ref="drawer"
    >
      <slot
        name="sectioncontent"
        :ready="ready"
        :title="!isMobile ? title : ''"
      />
    </div>
  </section>
</template>

<script>
import OpenCloseEvents from '@/Scripts/lib/helper/openCloseHelper';
import { eventBus } from '@/Scripts/lib/helper/eventBus.js';
import ScrollTo from 'vue-scrollto';

export default {
  extends: OpenCloseEvents,
  components: {},
  props: {
    title: String,
    reference: String,
    defaultOpen: {
      type: Boolean,
      default: false
    },
    collapseOnOpen: Boolean,
    noPadding: Boolean
  },
  data () {
    return {
      open: this.defaultOpen || this.isStatic,
      isClosing: false,
      openDrawer: '-opened',
      closeDrawer: '-closed',
      drawerType: 'pageSection',
      slotElement: []
    };
  },
  computed: {
    isMobile () {
      return this.$mqAliases.sm || this.$mqAliases.xs;
    },
    ready () {
      return this.open || this.isClosing || this.isStatic;
    },
    isStatic () {
      return (this.$mqAliases.xs || this.$mqAliases.sm) && (this.reference === 'ProductReviews' || this.reference === 'ProductRecommender');
    },
    slotIsEmpty () {
      if (typeof this.slotElement !== 'undefined' && typeof this.slotElement.viewMode !== 'undefined' && this.slotElement.viewMode === 'hidden') {
        return true;
      }
      return false;
    },
    hideDesktopHeader () {
      if (typeof this.slotElement !== 'undefined' && typeof this.slotElement.viewMode !== 'undefined' && this.slotElement.viewMode === 'hideDesktopHeader') {
        return true;
      }
      return false;
    },
    backgroundColor () {
      if (typeof this.slotElement !== 'undefined' && typeof this.slotElement.backgroundColor !== 'undefined') {
        return {
          backgroundColor: this.slotElement.backgroundColor
        };
      }
      return {};
    }
  },

  updated () {
    // console.log(this.$children[0], this.title);
    if (typeof this.$children[0] !== 'undefined') {
      this.slotElement = this.$children[0];
    }
  },
  created () {
    eventBus.$on('drawerOpened', obj => {
      if (obj.type === this.drawerType) {
        if (this.collapseOnOpen) {
          this.open = false;
        }
      }
    });
    eventBus.$on('openPageSection', data => {
      if (data && data.section === this.reference) {
        if (this.$mqAliases.desktop || this.open) {
          ScrollTo.scrollTo(`#${data.section}`);
        } else {
          this.runOpen();
        }
      }
    });
  },

  mounted () {
    if (typeof this.$children[0] !== 'undefined') {
      this.slotElement = this.$children[0];
    }
  }
};
</script>

<style lang="scss" src="@/scss/components/accordion/components.accordion-drawer.scss"></style>
<style lang="scss" src="@/scss/components/accordion/components.accordion-button.scss"></style>

<style lang="scss">
.product-section {
  &.-notopen {
    overflow: hidden;
  }
  .-opened {
    display: block;
  }

  .-closed {
    display: none;
  }
  h2, h3 {
    transition: background-color 0.33s;
  }
}
</style>
